import http from './http.service';

export class NewsService {

  load(includePreview) {
    return http.get(`/news${includePreview ? '?preview=true' : ''}`)
        .then(x => x.data)
        .then(news => {
          return news.data.map(item => {
            item.meta = item.meta && !Array.isArray(item.meta) ? item.meta : {};
            return item;
          });
        })
  }

  loadLatest() {
    return http.get(`/news/latest`)
        .then(x => x.data)
        .then(news => {
          return news.data.map(item => {
            item.meta = item.meta && !Array.isArray(item.meta) ? item.meta : {};
            return item;
          });
        })
  }
}